import { useRef, useState } from "react";
import { SectionContainer } from "../components/SectionContainer";
import { AiOutlineLinkedin, AiOutlineGithub } from "react-icons/ai";
import emailjs from "@emailjs/browser";

export const Contact = () => {
  const formRef = useRef<HTMLFormElement>(null);
  const [disableButton, setDisableButton] = useState(false);

  const { REACT_APP_SERVICE_ID, REACT_APP_TEMPLATE_ID, REACT_APP_PUBLIC_KEY } =
    process.env as { [key: string]: string };

  const sendEmail = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setDisableButton(true);

    if (
      !formRef.current ||
      !REACT_APP_SERVICE_ID ||
      !REACT_APP_TEMPLATE_ID ||
      !REACT_APP_PUBLIC_KEY
    ) {
      setDisableButton(false);
      return;
    }

    emailjs
      .sendForm(
        REACT_APP_SERVICE_ID,
        REACT_APP_TEMPLATE_ID,
        formRef.current,
        REACT_APP_PUBLIC_KEY,
      )
      .then(
        (result) => {
          (e.target as HTMLFormElement).reset();
          alert("Submission successful");
          setDisableButton(false);
          console.log(result.text);
        },
        (error) => {
          alert("Submission failed, please try again later");
          setDisableButton(false);
          console.log(error.text);
        },
      );
  };

  return (
    <SectionContainer>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 py-12 items-center">
        {/* Left Section: CTA and Branding */}
        <div className="text-center lg:text-left space-y-8">
          <div className="space-y-4">
            <h2 className="text-4xl md:text-5xl font-bold text-white tracking-tight">
              Let's Connect
            </h2>
            <p className="text-gray-400 text-lg leading-relaxed max-w-lg mx-auto lg:mx-0">
              Interested in learning more about my work? Feel free to reach out
              for collaborations or just a friendly hello. Let's build something
              great together.
            </p>
          </div>

          <div className="flex justify-center lg:justify-start space-x-6">
            <a
              href="https://www.linkedin.com/in/reece-carey-b4b025199/"
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 bg-gray-900 rounded-full border border-gray-800 text-gray-400 hover:text-violet-500 hover:border-violet-500 transition-all duration-300 shadow-lg"
            >
              <AiOutlineLinkedin className="h-8 w-8" />
            </a>
            <a
              href="https://github.com/Racara306"
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 bg-gray-900 rounded-full border border-gray-800 text-gray-400 hover:text-violet-500 hover:border-violet-500 transition-all duration-300 shadow-lg"
            >
              <AiOutlineGithub className="h-8 w-8" />
            </a>
          </div>
        </div>

        {/* Right Section: Modern Contact Form */}
        <div className="bg-gray-900/40 p-8 md:p-12 rounded-[2.5rem] border border-gray-800 shadow-2xl backdrop-blur-md">
          <form ref={formRef} onSubmit={sendEmail} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-2 text-left">
                <label className="block text-sm font-medium text-gray-400 ml-1">
                  Name
                </label>
                <input
                  className="w-full bg-gray-800/50 border border-gray-700 rounded-2xl p-4 text-white placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent transition-all"
                  type="text"
                  name="user_name"
                  placeholder="Your Name"
                  required
                />
              </div>
              <div className="space-y-2 text-left">
                <label className="block text-sm font-medium text-gray-400 ml-1">
                  Email
                </label>
                <input
                  className="w-full bg-gray-800/50 border border-gray-700 rounded-2xl p-4 text-white placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent transition-all"
                  name="user_email"
                  type="email"
                  placeholder="Email Address"
                  required
                />
              </div>
            </div>
            <div className="space-y-2 text-left">
              <label className="block text-sm font-medium text-gray-400 ml-1">
                Subject
              </label>
              <input
                className="w-full bg-gray-800/50 border border-gray-700 rounded-2xl p-4 text-white placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent transition-all"
                name="subject"
                type="text"
                placeholder="Subject"
                required
              />
            </div>
            <div className="space-y-2 text-left">
              <label className="block text-sm font-medium text-gray-400 ml-1">
                Message
              </label>
              <textarea
                className="w-full bg-gray-800/50 border border-gray-700 rounded-2xl p-4 text-white placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent transition-all min-h-[120px] resize-none"
                name="message"
                placeholder="How can I help you?"
                required
              />
            </div>
            <button
              type="submit"
              disabled={disableButton}
              className={`w-full py-4 text-white font-bold rounded-2xl transition-all duration-300 active:scale-[0.98] shadow-lg ${
                disableButton
                  ? "bg-gray-800 cursor-not-allowed"
                  : "bg-violet-600 hover:bg-violet-500 shadow-violet-900/20"
              }`}
            >
              {disableButton ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      </div>
    </SectionContainer>
  );
};
